import React from 'react';
import { TEXTS } from 'application/pages/PointsPage/renderer/texts';
import CollapsibleSection from '../../CollapsibleSection';
import { CUT_MUSIC_EXAMPLE_IMAGES, DATA_TEST_IDS } from '../consts';
import { HelpContentProps } from '../types';
import styles from '../index.module.scss';

const HelpModalContent: React.FC<HelpContentProps> = ({ variant }) => {
  const content = TEXTS.CUT_MUSIC_HELP[variant];
  const images = CUT_MUSIC_EXAMPLE_IMAGES[variant];
  return (
    <div className={styles.inner}>
      <div>
        <div
          className={styles.text}
          data-testid={DATA_TEST_IDS.INTRO}>
          {content.description}
        </div>
        {variant === 'cut' && (
          <ul className={styles.list}>
            <li>{TEXTS.CUT_MUSIC_HELP_MODAL_BULLET_0SEC}</li>
            <li>{TEXTS.CUT_MUSIC_HELP_MODAL_BULLET_30_60SEC}</li>
          </ul>
        )}
      </div>
      <CollapsibleSection title={TEXTS.CUT_MUSIC_HELP_MODAL_EXAMPLE_TITLE}>
        <div className={styles.exampleContent}>
          <div className={styles.text}>{content.example}</div>
          {images.map(({ name, src }) => (
            <img
              key={name}
              className={styles.image}
              data-testid={DATA_TEST_IDS.IMAGE(name)}
              alt=""
              src={src}
            />
          ))}
        </div>
      </CollapsibleSection>
    </div>
  );
};

export default HelpModalContent;
